export const EXPAND_NAV_DRAWER = 'EXPAND_NAV_DRAWER';
export const MINIMIZE_NAV_DRAWER = 'MINIMIZE_NAV_DRAWER';
export const CLIP_NAV_DRAWER = 'CLIP_NAV_DRAWER';
export const UNCLIP_NAV_DRAWER = 'UNCLIP_NAV_DRAWER';
export const SET_NAV_DRAWER = 'SET_NAV_DRAWER';
export const TOGGLE_SIDE_NAV = 'TOGGLE_SIDE_NAV';

export const SET_MAIN_NAV_ACTIVE = 'SET_MAIN_NAV_ACTIVE';
export const DELETE_SIDE_NAV_ITEM = 'DELETE_SIDE_NAV_ITEM';

export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';

// LOGIN_REDIRECT_ROUTE Action Types

export const GET_LOGIN_REDIRECT_ROUTE = 'GET_LOGIN_REDIRECT_ROUTE';
export const FETCH_LOGIN_REDIRECT_ROUTE = 'FETCH_LOGIN_REDIRECT_ROUTE';
export const SET_LOGIN_REDIRECT_ROUTE = 'SET_LOGIN_REDIRECT_ROUTE';
export const INSERT_LOGIN_REDIRECT_ROUTE = 'INSERT_LOGIN_REDIRECT_ROUTE';
export const UPDATE_LOGIN_REDIRECT_ROUTE = 'UPDATE_LOGIN_REDIRECT_ROUTE';
export const DELETE_LOGIN_REDIRECT_ROUTE = 'DELETE_LOGIN_REDIRECT_ROUTE';



// LOGIN_USER Action Types

export const GET_LOGIN_USER = 'GET_LOGIN_USER';
export const FETCH_LOGIN_USER = 'FETCH_LOGIN_USER';
export const SET_LOGIN_USER = 'SET_LOGIN_USER';
export const INSERT_LOGIN_USER = 'INSERT_LOGIN_USER';
export const UPDATE_LOGIN_USER = 'UPDATE_LOGIN_USER';
export const DELETE_LOGIN_USER = 'DELETE_LOGIN_USER';



export const SET_APP_NAV_ITEMS = 'SET_APP_NAV_ITEMS';

export const FETCH_REQUEST_COUNT = 'FETCH_REQUEST_COUNT';

export const SET_REQUEST_COUNT = 'SET_REQUEST_COUNT';


// export const RESET_STATE = 'RESET_STATE';


export * from './i18n/types';
export * from './account/types';